var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardInterview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_520_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4457 8.62779C17.5742 8.62779 19.2996 6.90167 19.2996 4.77239C19.2996 2.64311 17.5742 0.916992 15.4457 0.916992C13.3173 0.916992 11.5918 2.64311 11.5918 4.77239C11.5918 6.90167 13.3173 8.62779 15.4457 8.62779Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4691 21.0836C16.0798 21.0836 13.9116 21.0836 13.9116 21.0836M13.9116 21.0836H3.56389C3.02354 21.0836 2.55151 20.7182 2.41592 20.195L0.955554 14.5601C0.760893 13.809 1.32776 13.0762 2.10352 13.0762H10.6544C11.1796 13.0762 11.6423 13.4218 11.7915 13.9255L13.9116 21.0836Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81836 13.7507V12.78C9.81836 11.1422 11.1457 9.81445 12.7831 9.81445H18.1189C19.7563 9.81445 21.0837 11.1422 21.0837 12.78V15.746C21.0837 17.3838 19.7563 18.7115 18.1189 18.7115H16.2696H13.7473",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4131 12.834C17.4131 14.1443 17.0564 15.4491 15.7465 15.4491H13.2891",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_520_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInterview);
export default __webpack_public_path__ + "static/media/dashboard-interview.a4a9062ba18c79736c90e1d5850e6c1e.svg";
export { ForwardRef as ReactComponent };